import clientRoutes, { ClientRoutes } from "../routes/client/client.routes"
import { CLIENT_DEPARTMENTS, EMPLOYEE_DEPARTMENTS } from "../config/departments"
import { CLIENT_DESIGNATIONS, EMPLOYEE_DESIGNATIONS } from "../config/designations"
import kmtRoutes from "../routes/knowledge-management/kmt.routes"
import { Route } from "react-router-dom"
import { CONNECT_TO_OUTLOOK } from "../config/routes"
import loadable from "@loadable/component"
import CenteredSpinner from "../components/centered-spinner/CenteredSpinner"
const options =  {
  fallback : <CenteredSpinner />
}
const EnterBasicDetailsForOutlook = loadable(() => import(/* webpackChunkName: "EnterBasicDetailsForOutlook" */  "../components/outlook/authenticate/EnterBasicDetailsForOutlook"),options)

export const displayPagesAsPerUser = (userDepartment = CLIENT_DEPARTMENTS.CLIENT, userDesignation = CLIENT_DESIGNATIONS.CLIENT) => {
  let outlookAuthenticateUrl = <Route path={CONNECT_TO_OUTLOOK} element={<EnterBasicDetailsForOutlook userDepartment={userDepartment} userDesignation={userDesignation} />} />
  if (userDepartment === CLIENT_DEPARTMENTS.CLIENT && userDesignation === CLIENT_DESIGNATIONS.CLIENT) {
    return ClientRoutes()
  }
  else {
    let finalReturn = null
    if (userDepartment === EMPLOYEE_DEPARTMENTS.KNOWLEDGE_MANAGEMENT && userDesignation === EMPLOYEE_DESIGNATIONS.KMT_ASSOCIATE) {
      return kmtRoutes
    }
    if (userDepartment === EMPLOYEE_DEPARTMENTS.SALES && userDesignation === EMPLOYEE_DESIGNATIONS.SALES_ASSOCIATE) {
      // * Use this structure for all employee routes!
      finalReturn = kmtRoutes
    }
    if (userDepartment === EMPLOYEE_DEPARTMENTS.CLIENT_SERVICES && userDesignation === EMPLOYEE_DESIGNATIONS.CLIENT_SERVICES) {
      // * Use this structure for all employee routes!
      finalReturn = kmtRoutes
    }
    return (<>{finalReturn}{outlookAuthenticateUrl}</>)
  }
}